import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WhatsAppMessage_contactList, WhatsAppMessage_markRead, WhatsAppMessage_messageList, WhatsAppMessage_media, WhatsAppMessage_send } from 'src/app/GlobalVariables';
import {
  WhatsAppContactDTO, WhatsAppContactListRequestDTO, WhatsAppContactMarkReadRequestDTO, WhatsAppMessageDTO,
  WhatsAppMediaRequestDTO, WhatsAppMessageListRequestDTO, WhatsAppSendRequestDTO, WhatsAppSendResponseDTO
} from './whatsapp-inbox.interface';

@Injectable({ providedIn: 'root' })
export class WhatsappInboxService {
  private http = inject(HttpClient);

  contactList(data: WhatsAppContactListRequestDTO): Observable<{ items: WhatsAppContactDTO[] }> {
    return this.http.post<{ items: WhatsAppContactDTO[] }>(WhatsAppMessage_contactList, data);
  }

  messageList(data: WhatsAppMessageListRequestDTO): Observable<{ items: WhatsAppMessageDTO[] }> {
    return this.http.post<{ items: WhatsAppMessageDTO[] }>(WhatsAppMessage_messageList, data);
  }

  markRead(data: WhatsAppContactMarkReadRequestDTO): Observable<void> {
    return this.http.post<void>(WhatsAppMessage_markRead, data);
  }

  send(data: WhatsAppSendRequestDTO): Observable<WhatsAppSendResponseDTO> {
    return this.http.post<WhatsAppSendResponseDTO>(WhatsAppMessage_send, data);
  }

  /** The file itself; a JSON blob ({ message }) means it could not be fetched from Meta. */
  media(data: WhatsAppMediaRequestDTO): Observable<Blob> {
    return this.http.post(WhatsAppMessage_media, data, { responseType: 'blob' });
  }
}
